"use client";

import { RiGroup2Fill, RiGroup2Line } from "@remixicon/react";
import { cn } from "@/lib/utils";

export interface SocialFilterProps {
	/** Whether the filter is currently active */
	isActive: boolean;
	/** Callback when the filter button is clicked */
	onClick: () => void;
	/** Whether the button should be disabled */
	disabled?: boolean;
	/** Optional count of friends attending (can be displayed as badge) */
	friendCount?: number;
	/** Additional CSS classes */
	className?: string;
}

/**
 * Social filter button component for filtering by friends attending
 * Displays an icon that toggles between filled and outline states
 */
export function SocialFilter({
	isActive,
	onClick,
	disabled = false,
	friendCount,
	className,
}: SocialFilterProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={cn(
				"relative flex h-10 w-10 items-center justify-center rounded-xl transition-colors active:scale-[0.99]",
				isActive
					? "bg-primary text-primary-foreground"
					: "border border-input bg-background text-foreground hover:bg-accent",
				disabled && "cursor-not-allowed opacity-50",
				className,
			)}
			aria-label={isActive ? "Hide friends attending" : "Show friends attending"}
			title={isActive ? "Hide friends attending" : "Show friends attending"}
		>
			{isActive ? (
				<RiGroup2Fill className="h-5 w-5" />
			) : (
				<RiGroup2Line className="h-5 w-5" />
			)}
			{friendCount !== undefined && friendCount > 0 && (
				<span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-primary px-1 text-xs font-medium text-primary-foreground">
					{friendCount > 99 ? "99+" : friendCount}
				</span>
			)}
		</button>
	);
}
